export enum UserMemberTransferStatusEnum {
    REQUESTED = 'REQUESTED',
    HUMAN = 'HUMAN',
    EMAIL = 'EMAIL',
}
